export enum DynamoDBEventType {
  Insert = 'INSERT',
  Modify = 'MODIFY',
  Remove = 'REMOVE',
}
